import axios from "axios";
const API = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getDocumentosLogistica = async (productId) => {
  const { data } = await axios.get(
    `${API}/api/documentos-logistica/${productId}`,
    { headers: authHeaders() },
  );
  return data;
};

export const getDocumentosLogisticaPorEnvio = async (logisticaEnvioId) => {
  const { data } = await axios.get(
    `${API}/api/documentos-logistica/envio/${logisticaEnvioId}`,
    { headers: authHeaders() },
  );
  return data;
};

export const subirDocumentoLogistica = async (formData) => {
  const file = formData.get("file");
  const nameToSend =
    String(formData.get("nombreDocumento") || "").trim() ||
    (file && file.name) ||
    "";
  if (nameToSend && !formData.get("nombreDocumento")) {
    formData.append("nombreDocumento", nameToSend);
  }
  const { data } = await axios.post(
    `${API}/api/documentos-logistica/upload`,
    formData,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "multipart/form-data",
        ...(nameToSend ? { "X-Document-Name": nameToSend } : {}),
      },
    },
  );
  return data;
};

export const eliminarDocumentoLogistica = async (id_Documento) => {
  await axios.delete(`${API}/api/documentos-logistica/${id_Documento}`, {
    headers: authHeaders(),
  });
};
